import { createReducer, createAction } from '@reduxjs/toolkit';
import type { RootState } from '@store/types';
import type { AppDispatch } from '@reducers/utils/types';
import type { LogsState, LogEntry, EventLogEntry } from './types';

// Re-export types for consumers
export type { LogsState, LogEntry, EventLogEntry } from './types';

// === State ===

const initState: LogsState = {
  history: [],
  eventsHistory: [],
};

// === Actions ===

export const setHistory = createAction<LogEntry[]>('logs/setHistory');
export const setEventsHistory = createAction<EventLogEntry[]>('logs/setEventsHistory');

// === Thunks ===

export const addLogToHistory = (data: LogEntry) => async (dispatch: AppDispatch, getState: () => RootState) => {
  const {
    logs: { history },
  } = getState();

  const newHistory = [data, ...history];
  if (newHistory.length > 20) {
    newHistory.length = 20;
  }

  dispatch(setHistory(newHistory));
};

export const addEventLogToHistory =
  (eventType: string, eventData: Record<string, unknown>) => async (dispatch: AppDispatch, getState: () => RootState) => {
    const {
      logs: { eventsHistory = [] },
    } = getState();

    const eventLog: EventLogEntry = {
      timestamp: new Date().toISOString(),
      eventType,
      data: eventData,
    };

    const newEventsHistory = [eventLog, ...eventsHistory];
    if (newEventsHistory.length > 200) {
      newEventsHistory.length = 200;
    }

    dispatch(setEventsHistory(newEventsHistory));
  };

// === Reducer ===

export default createReducer(initState, (builder) => {
  builder
    .addCase(setHistory, (state, action) => ({
      ...state,
      history: action.payload,
    }))
    .addCase(setEventsHistory, (state, action) => ({
      ...state,
      eventsHistory: action.payload,
    }));
});
